<div class="make-it-yours">
	<h2>{{ 'COMMON.APPOINTMENT_FEES' | translate }}</h2>
	<form [formGroup]="form">
		<!-- /fees answered 404: no configured price for this selection. Unpriced means
		     "not bookable online", never free. -->
		<div class="govuk-warning-text" *ngIf="dataStore.feesUnavailable">
			<span class="govuk-warning-text__icon" aria-hidden="true">!</span>
			<strong class="govuk-warning-text__text">
				<span class="govuk-visually-hidden">Warning</span>
				We are unable to calculate the fee for this booking, so it cannot be booked
				online. Please contact the register office to complete your booking.
			</strong>
		</div>

		<ng-container *ngIf="!dataStore.feesUnavailable">
			<table class="govuk-table govuk-table--small-text-until-tablet" *ngIf="dataStore.serviceFees">
				<thead class="govuk-table__head">
					<tr class="govuk-table__row">
						<th scope="col" class="govuk-table__header">Items</th>
						<th scope="col" class="govuk-table__header">Quantity</th>
						<th scope="col" class="govuk-table__header">Total</th>
						<ng-container *ngIf="dataStore.overDaysAway">
							<th scope="col" class="govuk-table__header">Payable today</th>
						</ng-container>
					</tr>
				</thead>
				<tbody class="govuk-table__body">
					<tr class="govuk-table__row" *ngFor="let fee of dataStore.serviceFees">
						<th scope="row" class="govuk-table__header">{{ fee.item }}</th>
						<td class="govuk-table__cell">{{ fee.quantity }}</td>
						<td class="govuk-table__cell">
							{{ fee.cost * fee.quantity | currency : 'GBP' : 'symbol' : '1.2-2' }}
						</td>
						<ng-container *ngIf="dataStore.overDaysAway">
							<td class="govuk-table__cell">
								{{
								(fee.depositEligible ? fee.deposit : fee.cost) * fee.quantity
								| currency : 'GBP' : 'symbol' : '1.2-2'
								}}
							</td>
						</ng-container>
					</tr>
					<tr class="govuk-table__row">
						<td class="govuk-table__header total">Total</td>
						<td class="govuk-table__header">&nbsp;</td>
						<td class="govuk-table__header">
							{{ costTotal | currency : 'GBP' : 'symbol' : '1.2-2' }}
						</td>
						<ng-container *ngIf="dataStore.overDaysAway">
							<td class="govuk-table__header total">
								{{ depositTotal | currency : 'GBP' : 'symbol' : '1.2-2' }}
							</td>
						</ng-container>
					</tr>
				</tbody>
			</table>
			<p class="govuk-body" *ngIf="!dataStore.serviceFees">Calculating fees</p>

			@for(question of questions; track question.id) { @if(question.visible) {
			<label tabindex="0" for="{{ question.id }}">
				<span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">*</span>
				{{ question.name | translateSplit }}
			</label>
			@if(question.detailType === 'number') {
			<select formControlName="{{ question.id }}" class="govuk-select" [id]="question.id" [name]="question.id"
				[items]="question.options" (change)="onQuestionChange(question)">
				@for(option of question.options; track $index) {
				<option value="{{ option.name }}" [attr.selected]="option === question.defaultValue">
					{{ option.name }}
				</option>
				}
			</select>
			}
			@if(question.detailType === 'select' || question.detailType === 'number') {
			<div class="number-input-container">
				<button class="btn btn-minus" [disabled]="question.answer === question.minimumValue"
					(click)="updateNumberInput(question.id, false, question.minimumValue, question.maximumValue)"
					aria-label="Decrease number of certificates by 1 (minus)">
					<i class="ph ph-minus" aria-hidden="true"></i>
				</button>
				<input type="number" [min]="question.minimumValue" [max]="question.maximumValue" class="number-input"
					formControlName="{{ question.id }}" [id]="question.id" [name]="question.id"
					[value]="question.defaultValue" aria-live="polite" />
				<button class="btn btn-plus"
					(click)="updateNumberInput(question.id, true, question.minimumValue, question.maximumValue)"
					aria-label="Increase number of certificates by 1 (plus)"
					[disabled]="question.answer === question.maximumValue">
					<i class="ph ph-plus" aria-hidden="true"></i>
				</button>
			</div>
			} } }

			<div class="govuk-form-group mb-0">
				<fieldset class="govuk-fieldset">
					<legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
						<h2 class="body-bold">
							{{ 'COMMON.PAYABLE_TODAY' | translate }}
						</h2>
					</legend>
					<!-- No payment choice: the 84-day rule in calculateTotal() decides deposit vs full. -->
					<input type="hidden" formControlName="payment_type" />
					<p *ngIf="dataStore.overDaysAway">
						As your ceremony is more than 84 days away, a deposit of
						<b>{{ depositTotal | currency : 'GBP' : true }}</b> is payable today. The balance of
						<b>{{ costTotal - depositTotal | currency : 'GBP' : true }}</b> is due 84 days before your
						ceremony.
					</p>
					<p>
						In order to confirm your booking, we will need to take a payment of
						<b>{{ totalCost | currency : 'GBP' : true }}</b> today by credit or debit card. We are not
						able to hold bookings without payment and your booking will be cancelled if payment is
						not received.
					</p>
					<p class="mb-0">
						We'll take payment on the next page.
					</p>
				</fieldset>
			</div>
		</ng-container>
	</form>
</div>
